import axios from "axios";

const axiosBaseURL = axios.create({
 baseURL: "https://dev.ezonefly.com/",
});

export default axiosBaseURL;